import { Dispatch, AnyAction } from "redux"
import { ThunkDispatch } from "redux-thunk"

import { actionHandler } from "../@common/actions"
import { UpdateTreeDragAndDropInput } from "../@common/types"
import { FETCH_SORTING_OUTPUT_MATERIALS } from "./constants"
import {
  getSortingOutputMaterials,
  postSortingOutputMaterial,
  putSortingOutputMaterialTree,
  deleteSortingOutputMaterial,
  SortingOutputMaterial,
  PostSortingOutputMaterialInput,
  DeleteSortingOutputMaterialInput,
} from "./service/api"

export const setSortingOutputMaterials = (payload: {
  sortingOutputMaterials: SortingOutputMaterial[]
}) => ({
  type: FETCH_SORTING_OUTPUT_MATERIALS,
  payload,
})

export const fetchSortingOutputMaterials = () => async (dispatch: Dispatch) => {
  actionHandler(getSortingOutputMaterials({}), (sortingOutputMaterials) => {
    dispatch(setSortingOutputMaterials({ sortingOutputMaterials }))
  })
}

export const createSortingOutputMaterial =
  (credentials: PostSortingOutputMaterialInput) =>
  async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    actionHandler(postSortingOutputMaterial(credentials), () => {
      dispatch(fetchSortingOutputMaterials())
    })
  }

export const updateSortingOutputMaterialTree =
  (credentials: UpdateTreeDragAndDropInput) =>
  async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    actionHandler(putSortingOutputMaterialTree(credentials), () => {
      dispatch(fetchSortingOutputMaterials())
    })
  }

export const deleteSortingOutputMaterialTree =
  (credentials: DeleteSortingOutputMaterialInput) =>
  async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    actionHandler(deleteSortingOutputMaterial(credentials), () => {
      dispatch(fetchSortingOutputMaterials())
    })
  }
